import React, { memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { COLORS, ProductsCodeEnum, ProductsEnum } from "../../../core/consts/redesign/commonRedesign";
import { Close } from "../../../core/consts/redesign/icons";
import { actions } from "../../../core/store";
import { ResponseItemDataType } from "../../../core/types/proposalTypes";
import IconButtonMain from "../../../UIcomponentsRedesign/IconButtonMain/IconButtonMain";
import ModalCustom from "../../../UIcomponentsRedesign/ModalCustom";
import SmallProposalCard from "../small-proposal-card/SmallProposalCard";
import { useStylesNewProposalsModal } from "./useStylesNewProposalsModal";

type propsType = {
  isOpen: boolean,
  setCloseModal: () => void,
  proposalsInfo: ResponseItemDataType[]
}

const NewProposalsModal: React.FC<propsType> = (props) => {
  const classes = useStylesNewProposalsModal()
  const dispatch = useDispatch();
  const { proposalsInfo: proposals } = props;
  const [openModal, setOpenModal] = useState(props.isOpen);
  const productsUniq = uniq(proposals.map(item => item.productAlias));
  const telegramUrl = 'https://t.me/finguruhub'
  useEffect(() => {
    setOpenModal(props.isOpen)
    // change new proposal shown state to false as already shown
    dispatch(actions.setNewProposalsShown(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen])

  const handleClose = () => {
    setOpenModal((prev) => !prev)
    props.setCloseModal()
  }

  function uniq(a: string[]) {
    return Array.from(new Set(a));
  }

  return (
    <ModalCustom isOpen={openModal} onClose={handleClose}>
      <div className={classes.headerBox}>
        <h4 className={classes.title}>
          Новые предложения
        </h4>
        <IconButtonMain
          color="noBgGray"
          style={{ padding: 0, height: '24px', width: '24px' }}
          buttonId="close-button"
          handleClickEvent={handleClose}
          icon={<Close color={COLORS.gray2} />}
        />
      </div>
      <div className={classes.contentBox}>
        <h4 className={classes.desc}>
          Привет всем залетевшим на эксклюзивные офферы по РКО. Подпишись на наш
          <a
            className={classes.link}
            target="_blank"
            href={telegramUrl} rel="noreferrer"
          > тг-канал</a>, чтобы быть в курсе всех изменений и улетных кейсов. А сейчас вашему вниманию новые предложения:
        </h4>
        {proposals && proposals.length > 0 &&
          productsUniq.map((product, index) => {
            const hasProposals = proposals.some(proposal => proposal.productAlias === product);

            return <div className={classes.productBox} key={index}>
              {hasProposals &&
                <h2 className={classes.productTitle}>
                  {ProductsEnum[ProductsCodeEnum[product as ProductsCodeEnum]]} {`(${proposals.filter(proposal => proposal.productAlias === product).length}):`}
                </h2>
              }

              {proposals
                .filter(elem => elem.productAlias === product)
                .map(filteredElem => (
                  <SmallProposalCard proposal={filteredElem} key={filteredElem.id} id={filteredElem.id} />
                ))}

            </div>
          })}
      </div>
    </ModalCustom>
  )
}

export default memo(NewProposalsModal)